import React, { memo, useCallback } from 'react'
import {
  Text,
  IcoMoon,
  KeyboardArrowDownIcon,
  useResponsiveWrapperContext,
} from '@usap/uicomponents'

import {
  Container,
  PartsAndAccessories,
  GuidesAndArticles,
} from './Category.css'

const Category = ({
  scrollToDiv = () => {},
  linkHeading,
  catParts,
  isVLP,
  hasBlogs,
}) => {
  const { isDesktop } = useResponsiveWrapperContext()

  const anchorCategories = useCallback(() => scrollToDiv('categories'), [scrollToDiv])
  const anchorGuides = useCallback(() => scrollToDiv('GuidesAndArticlesHeading'), [scrollToDiv])

  if (!isDesktop || !isVLP) return null

  return (
    <Container direction="row">
      {Array.isArray(catParts) && catParts.length > 0 && (
        <PartsAndAccessories
          id="partsAndAccessories"
          direction="row"
          align="center"
          onClick={anchorCategories}
        >
          <Text size="small" color="blueLink">
            {linkHeading}
          </Text>
          <IcoMoon icon={KeyboardArrowDownIcon} color="brand" size="24px" />
        </PartsAndAccessories>
      )}

      {hasBlogs && (
        <GuidesAndArticles
          id="guidesAndArticles"
          direction="row"
          align="center"
          onClick={anchorGuides}
        >
          <Text size="small" color="blueLink">
            Guides & Articles
          </Text>
          <IcoMoon icon={KeyboardArrowDownIcon} color="brand" size="24px" />
        </GuidesAndArticles>
      )}
    </Container>
  )
}

export default memo(Category)
